import { getScoreClass } from '../../../../../functions/functions';
import BaseballDiamond from '../../../baseballDiamond';
import MomioItemSponsored from '../../../momioItemSponsored';
import './rightBodyCard.sass';

/**
 * Componente que muestra los momios y marcadores del lado derecho de la tarjeta
 * para deportes globales (como fútbol, NFL, etc.), incluyendo lógica visual
 * para diferenciar ganadores, perdedores o empates.
*/
export default function RightBodyCardGlobal({ data, flagMomios, patrocinador }) {
  const { left_class, left_score, right_class, right_score, class: classGame, left_red_card, right_red_card, sport, baseball_data } = data;

  const showMomios = (flagMomios === "true" || flagMomios === true) && !["clarosports-finished-game", "clarosports-error-game"].includes(classGame);
  const isNext = classGame === "clarosports-next-game";
  const isError = classGame === "clarosports-error-game";
  const islive = classGame === 'clarosports-in-progress-game';
  const patrocinadorKey = patrocinador?.toLowerCase() || "";
  const metadata = data[`${patrocinadorKey}_metadata`] || {};

  /**
  * Renderiza el marcador para un equipo en su posición respectiva.
  */
  const renderMarcador = (position, score, teamClass, flag, red_card) => {
    const baseScoreClass = `body-card-global__right-team-${position}-score`;
    const finalClass = getScoreClass(baseScoreClass, teamClass, classGame);

    const content = (!isNext && score !== "" && !isError)
      ? score
      : (position !== 'middle' ? '-' : '');

    return (
      <div className={sport === 'FOOT' ? 'body-card-global__right-score-flag' : ""}>
        <div className={finalClass}>
          <span>{content}</span>
        </div>
        {flag && red_card && sport === 'FOOT' &&
          <div className='flag-red'></div>
        }
      </div>
    );
  };

  if (!data || Object.keys(data).length === 0) return null;

  let isReady = data && Object.keys(data).length > 0;

  return (
    <>
      {isReady && (
        <>
          {/* momios */}
          <div className='body-card-global__right-momios'>
            <MomioItemSponsored position="left" metadata={metadata} showMomios={showMomios} baseClass="body-card-global__right-team" />
            <MomioItemSponsored position="middle" metadata={metadata} showMomios={showMomios} baseClass="body-card-global__right-team" />
            <MomioItemSponsored position="right" metadata={metadata} showMomios={showMomios} baseClass="body-card-global__right-team" />
          </div>

          {/* marcadores */}
          <div className='body-card-global__right-score'>
            {renderMarcador('left', left_score, left_class, true, left_red_card)}
            {renderMarcador('right', right_score, right_class, true, right_red_card)}
          </div>


          {(sport === 'BASE' && islive) && 
            <BaseballDiamond sport={sport} islive={islive} baseball_data={baseball_data} />
          }
        </>)}
    </>
  )
}